import { Collection } from '@/kernel/collection';

import StringCell from '@/components/cells/string-cell.vue';
import DateCell from '@/components/cells/date-cell.vue';
import BooleanCell from '@/components/cells/boolean-cell.vue';
import EditCollectionCell from '@/components/cells/edit-collection-cell.vue';
import CollectionNameCell from '@/components/cells/collection-name-cell.vue';

import { DateRangeFilterAdapter, SelectFilterAdapter } from '@/kernel/adapters';

import DateRangeInput from '@/components/inputs/date-range-input.vue';
import TextInput from '@/components/inputs/text-input.vue';
import CheckboxInput from '@/components/inputs/checkbox-input.vue';
import SelectInput from '@/components/inputs/select-input.vue';

const isPublishedOptions = [
  {value: null, label: 'Any'},
  {value: false, label: 'Unpublished'},
  {value: true, label: 'Published'}
];

export class Source extends Collection {
  config = {
    autoRoute: true,
    requiresSuperAdmin: true,
    key: 'source',
    pluralLabel: 'Sources',
    singleLabel: 'Source',
    indexUrl: '/source',
    createUrl: '/source/create',
    searchKeys: ['name'],
    editUrlPrefix: '/source',
    idKey: 'id',
    nameKey: 'name',
    payloadEndpoint: '/source',
    defaultSort: {
      key: 'name',
      order: 1
    },
    indexColumns: [
      {name: 'Actions', key: 'edit', sortable: false, cell: EditCollectionCell, props: {collection: 'source'}},
      {name: 'Name', key: 'name', sortable: true, cell: StringCell},
      {name: 'Is Published', key: 'isPublished', sortable: false, cell: BooleanCell},
      {name: 'Updated', key: 'updatedAt', sortable: true, cell: DateCell},
      {name: 'Created', key: 'createdAt', sortable: true, cell: DateCell}
    ],
    indexFilters: [
      {key: 'isPublished', label: 'Is Published', input: SelectInput, adapter: SelectFilterAdapter, props: {label: 'Is Published', options: isPublishedOptions}},
      {key: 'updatedAt', label: 'Updated at', input: DateRangeInput, adapter: DateRangeFilterAdapter, props: {label: 'Updated at'}},
      {key: 'createdAt', label: 'Created at', input: DateRangeInput, adapter: DateRangeFilterAdapter, props: {label: 'Created at'}}
    ],
    createFormFields: [
      {key: 'isPublished', label: 'Is Published', input: CheckboxInput, props: {label: 'Is Published'}},
      {key: 'name', label: 'Name', input: TextInput, props: {label: 'Name'}},
    ],
    editFormFields: [
      {key: 'isPublished', label: 'Is Published', input: CheckboxInput, props: {label: 'Is Published'}},
      {key: 'name', label: 'Name', input: TextInput, props: {label: 'Name'}}
    ]
  }
}
